const prepareSuggestions = (suggestions) => {
  const element = document.createElement('div');

  return suggestions.map(({ term, name }) => {
    element.innerHTML = term;

    return {
      name,
      suggestion: [...element.childNodes]
        .map(({ tagName, textContent }) => ({ highlight: !!tagName, part: textContent }))
  };
  });
};

export default prepareSuggestions;
